import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// Import translation files
import enCommon from './locales/en/common.json';
import enElection from './locales/en/election.json';
import enVoting from './locales/en/voting.json';
import enResults from './locales/en/results.json';
import enModal from './locales/en/modal.json';
import enValidation from './locales/en/validation.json';
import enPrivacy from './locales/en/privacy.json';

import deCommon from './locales/de/common.json';
import deElection from './locales/de/election.json';
import deVoting from './locales/de/voting.json';
import deResults from './locales/de/results.json';
import deModal from './locales/de/modal.json';
import deValidation from './locales/de/validation.json';
import dePrivacy from './locales/de/privacy.json';

import frCommon from './locales/fr/common.json';
import frElection from './locales/fr/election.json';
import frVoting from './locales/fr/voting.json';
import frResults from './locales/fr/results.json';
import frModal from './locales/fr/modal.json';
import frValidation from './locales/fr/validation.json';
import frPrivacy from './locales/fr/privacy.json';

import esCommon from './locales/es/common.json';
import esElection from './locales/es/election.json';
import esVoting from './locales/es/voting.json';
import esResults from './locales/es/results.json';
import esModal from './locales/es/modal.json';
import esValidation from './locales/es/validation.json';
import esPrivacy from './locales/es/privacy.json';

import ptCommon from './locales/pt/common.json';
import ptElection from './locales/pt/election.json';
import ptVoting from './locales/pt/voting.json';
import ptResults from './locales/pt/results.json';
import ptModal from './locales/pt/modal.json';
import ptValidation from './locales/pt/validation.json';
import ptPrivacy from './locales/pt/privacy.json';

import zhCNCommon from './locales/zh-CN/common.json';
import zhCNElection from './locales/zh-CN/election.json';
import zhCNVoting from './locales/zh-CN/voting.json';
import zhCNResults from './locales/zh-CN/results.json';
import zhCNModal from './locales/zh-CN/modal.json';
import zhCNValidation from './locales/zh-CN/validation.json';
import zhCNPrivacy from './locales/zh-CN/privacy.json';

import jaCommon from './locales/ja/common.json';
import jaElection from './locales/ja/election.json';
import jaVoting from './locales/ja/voting.json';
import jaResults from './locales/ja/results.json';
import jaModal from './locales/ja/modal.json';
import jaValidation from './locales/ja/validation.json';
import jaPrivacy from './locales/ja/privacy.json';

import hiCommon from './locales/hi/common.json';
import hiElection from './locales/hi/election.json';
import hiVoting from './locales/hi/voting.json';
import hiResults from './locales/hi/results.json';
import hiModal from './locales/hi/modal.json';
import hiValidation from './locales/hi/validation.json';
import hiPrivacy from './locales/hi/privacy.json';

import arCommon from './locales/ar/common.json';
import arElection from './locales/ar/election.json';
import arVoting from './locales/ar/voting.json';
import arResults from './locales/ar/results.json';
import arModal from './locales/ar/modal.json';
import arValidation from './locales/ar/validation.json';
import arPrivacy from './locales/ar/privacy.json';

// Language resources
const resources = {
  en: {
    common: enCommon,
    election: enElection,
    voting: enVoting,
    results: enResults,
    modal: enModal,
    validation: enValidation,
    privacy: enPrivacy,
  },
  de: {
    common: deCommon,
    election: deElection,
    voting: deVoting,
    results: deResults,
    modal: deModal,
    validation: deValidation,
    privacy: dePrivacy,
  },
  fr: {
    common: frCommon,
    election: frElection,
    voting: frVoting,
    results: frResults,
    modal: frModal,
    validation: frValidation,
    privacy: frPrivacy,
  },
  es: {
    common: esCommon,
    election: esElection,
    voting: esVoting,
    results: esResults,
    modal: esModal,
    validation: esValidation,
    privacy: esPrivacy,
  },
  pt: {
    common: ptCommon,
    election: ptElection,
    voting: ptVoting,
    results: ptResults,
    modal: ptModal,
    validation: ptValidation,
    privacy: ptPrivacy,
  },
  'zh-CN': {
    common: zhCNCommon,
    election: zhCNElection,
    voting: zhCNVoting,
    results: zhCNResults,
    modal: zhCNModal,
    validation: zhCNValidation,
    privacy: zhCNPrivacy,
  },
  ja: {
    common: jaCommon,
    election: jaElection,
    voting: jaVoting,
    results: jaResults,
    modal: jaModal,
    validation: jaValidation,
    privacy: jaPrivacy,
  },
  hi: {
    common: hiCommon,
    election: hiElection,
    voting: hiVoting,
    results: hiResults,
    modal: hiModal,
    validation: hiValidation,
    privacy: hiPrivacy,
  },
  ar: {
    common: arCommon,
    election: arElection,
    voting: arVoting,
    results: arResults,
    modal: arModal,
    validation: arValidation,
    privacy: arPrivacy,
  },
};

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'election', 'voting', 'results', 'modal', 'validation', 'privacy'],
    
    detection: {
      // Detect language from localStorage first, then browser settings
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    react: {
      useSuspense: false, // Set to false to avoid suspense-related issues
    },
  });

export default i18n;